import { useEffect, useRef, useState } from 'react'
import { Search, X } from 'lucide-react'
import { useReviewsConfig } from '../../providers'

const DEBOUNCE_MS = 250

/**
 * Keyword search box for the reviews widget (#1692). Typing is debounced into
 * the provider's `searchQuery`; every layout filters the already-loaded
 * reviews by it. No network request is made.
 */
export function ReviewsSearch() {
  const { setSearchQuery } = useReviewsConfig()
  const [value, setValue] = useState('')
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => () => { if (timer.current) clearTimeout(timer.current) }, [])

  const onChange = (next: string) => {
    setValue(next)
    if (timer.current) clearTimeout(timer.current)
    timer.current = setTimeout(() => setSearchQuery(next), DEBOUNCE_MS)
  }

  const clear = () => {
    if (timer.current) clearTimeout(timer.current)
    setValue('')
    setSearchQuery('')
  }

  return (
    <div className="homerunner-reviews-search relative mb-6 max-w-md">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground pointer-events-none" aria-hidden="true" />
      <input
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Search reviews"
        aria-label="Search reviews"
        className="homerunner-reviews-search-input w-full rounded-md border border-border bg-background text-foreground pl-9 pr-9 py-2"
      />
      {value && (
        <button
          type="button"
          onClick={clear}
          aria-label="Clear search"
          className="homerunner-reviews-search-clear absolute right-2 top-1/2 -translate-y-1/2 p-1 text-muted-foreground"
        >
          <X className="w-4 h-4" aria-hidden="true" />
        </button>
      )}
    </div>
  )
}
